import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { BaseModal } from 'components/UI';
import { VehicleServices } from 'components/Vehicles/VehiclesWizard';

const ChangeServicesModal = ({ title, vehicle, step, open, handleClick, orgs }) => {
  return (
    <BaseModal
      size="lg"
      open={open}
      maxWidth={1160}
      loading={false}
      handleClick={handleClick}
      title={title || i18n.t('vehicle.edit_services')}
    >
      <VehicleServices showLabel={false} step={step} currentVehicle={vehicle} orgs={orgs} />
    </BaseModal>
  );
};

ChangeServicesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeServicesModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeServicesModal;
